import React, { Component } from 'react';

const ExampleColors = () =>
  <section id="colors">
    <h3 className="section-header">Colors</h3>
    <div className="row medium-up-4">
      <div className="column">
        <div className="color-block primary"></div>
        <h5>$color-primary</h5>
      </div>
      <div className="column">
        <div className="color-block secondary"></div>
        <h5>$color-secondary</h5>
      </div>
      <div className="column">
        <div className="color-block success"></div>
        <h5>$color-success</h5>
      </div>
      <div className="column">
        <div className="color-block danger"></div>
        <h5>$color-danger</h5>
      </div>
      <div className="column">
        <div className="color-block gray-lightest"></div>
        <h5>$color-gray-lightest</h5>
      </div>
      <div className="column">
        <div className="color-block gray-light"></div>
        <h5>$color-gray-light</h5>
      </div>
      <div className="column">
        <div className="color-block gray-medium"></div>
        <h5>$color-gray-medium</h5>
      </div>
      <div className="column">
        <div className="color-block gray-dark"></div>
        <h5>$color-gray-dark</h5>
      </div>
      <div className="column">
        <div className="color-block black"></div>
        <h5>$color-black</h5>
      </div>
      <div className="column">
        <div className="color-block modal-bg"></div>
        <h5>$color-modal-background</h5>
      </div>

    </div>
  </section>;

export { ExampleColors }



// WEBPACK FOOTER //
// ./styleguide/components/colors.jsx